import { render, staticRenderFns } from "./formCobrancaAvulsa.vue?vue&type=template&id=1f4136d4&scoped=true"
import script from "./formCobrancaAvulsa.vue?vue&type=script&lang=js"
export * from "./formCobrancaAvulsa.vue?vue&type=script&lang=js"
import style0 from "./formCobrancaAvulsa.vue?vue&type=style&index=0&id=1f4136d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4136d4",
  null
  
)

export default component.exports